import React from "react";

const QIA_AVATAR_SRC = (process.env.PUBLIC_URL || "") + "/assets/qia/avatarqia.png";

function QiaAvatar({ size = 26, className = "" }) {
    return (
        <img
            src={QIA_AVATAR_SRC}
            alt="Qia"
            className={["qia-spark", className].join(" ").trim()}
            style={{ width: size, height: size }}
        />
    );
}

export default QiaAvatar;
export { QIA_AVATAR_SRC };
